import { useMutation, useQueryClient, UseMutationResult } from "@tanstack/react-query";
import axiosInstance from "./axiosInstanse";
import { enum_api_uri } from "../utils/enum";

interface DeleteRequest {
    idx: number[];
}

interface DeleteResponse {
    statusCode: number;
    message: string;
}

export const useDeleteTmp = (onSuccessCallback?: () => void): UseMutationResult<DeleteResponse, Error, DeleteRequest> => {
    const queryClient = useQueryClient();

    return useMutation<DeleteResponse, Error, DeleteRequest>({
        mutationFn: async (body: DeleteRequest) => {
            const res = await axiosInstance.delete(enum_api_uri.tmp_remove, {
                data: body,
            });
            return res.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["usePostTmpList"] });
            onSuccessCallback?.();
        },
    });
};
